import { Box, Step, StepLabel, Stepper } from "@mui/material";
import { useBreakpoint } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

const SubscriptionStepper = styled(Stepper)`
  & .MuiStep-root:first-of-type {
    padding-left: 0;
  }
  & .MuiStep-root:last-of-type {
    padding-right: 0;
  }
  ${(p) => p.theme.media.mobileDown} {
    & .MuiStepLabel-iconContainer {
      padding-right: 0;
    }
  }
  span {
    font-family: ${(p) => p.theme.text.fonts.primary};
  }
  .MuiStepIcon-root.Mui-active,
  .MuiStepIcon-root.Mui-completed {
    color: ${(p) => p.theme.colors.primary};
  }
`;

type Props = {
  currentStep: number;
  steps: string[];
};

export const SubscriptionFlowStepper = (props: Props) => {
  const { currentStep, steps } = props;
  const isMobile = useBreakpoint("mobile");

  return (
    <Box sx={{ width: "100%", marginBottom: isMobile ? 3 : 5 }}>
      <SubscriptionStepper activeStep={currentStep}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{!isMobile && label}</StepLabel>
          </Step>
        ))}
      </SubscriptionStepper>
    </Box>
  );
};
